import {
    Button,
    ColourSolid,
    ContentBlock,
    FlexAlign,
    NavigationEntryType,
    Padding,
    SectionNavigation,
    useLayout,
    useTranslation
} from "@twigsby/frontend-framework";
import React, {ForwardedRef, forwardRef} from 'react';
import {useNavigate} from "react-router-dom";

const SendsNavigation = forwardRef((props: any, ref: ForwardedRef<HTMLDivElement>) => {
    const { t } = useTranslation();
    const { isLarge } = useLayout();
    const navigate = useNavigate();

    const SendsMenuEntries: Array<NavigationEntryType> = [
        { title: t('sends.title'), path: '/send-mail/send'},
        { title: t('sends.profiles.title'), path: '/send-mail/pages'},
        { title: t('sends.users.title'), path: '/send-mail/users'},
        { title: t('sends.history.title'), path: '/send-mail/sends'},
        { title: t('sends.profilesHistory.title'), path: '/send-mail/history'},
    ]

    return (
        <SectionNavigation
            ref={ref}
            title={!isLarge ? props.title : t('sends.sendMail')}
            entries={SendsMenuEntries}
            rounded={true}
            addonContent={props.addonContent}
        >
            <ContentBlock
                stacked={true}
                title={t('sends.feature.title')}
                content={t('sends.feature.description')}
                media={
                    <img src={`${process.env.PUBLIC_URL}/images/sends.svg`} alt={t('sends.feature.imageAlt')} className={'text-center'}/>
                }
                button={
                    <Button
                        title={t('sends.feature.button')}
                        onClick={() => navigate('/send-mail/create')}
                        colour={ColourSolid.Secondary}
                        fullWidth={true}
                    />
                }
                showBorder={true}
                align={FlexAlign.Start}
                extraClass={'text-center mt-md'}
                padding={Padding.Large}
            />
        </SectionNavigation>
    );
});

export default SendsNavigation;
